module.exports = __webpack_public_path__ + "media/images/right_arrow-09e598a9b9ca3b4de4e574526dcfb8f2.svg";